export const APP_CONFIG = {
  debug: true,
  apiUrl: process.env.VUE_APP_API_URL,
  cdnUrl: process.env.VUE_APP_CDN_URL
};
